// extracted by mini-css-extract-plugin
export var underlay = "SideBar-module--underlay--3wtDV";
export var side_bar_container = "SideBar-module--side_bar_container--3YTgk";
export var side_bar_header = "SideBar-module--side_bar_header--1EPHW";
export var side_bar_nav = "SideBar-module--side_bar_nav--IUjdk";
export var show_side_bar = "SideBar-module--show_side_bar--1mvAO";